import axios from 'axios';
import { Cancelation } from 'store/requestsCancellation/actions';
import { Auth } from 'store/auth/actions';
import { store } from '../App';
import { errorToast } from './notifications';

const baseURL = process.env.REACT_APP_API_URL;

const apiCall = axios.create({
  baseURL,
});

// Прикрепляем токен отмены для отмены запросов по требованию
apiCall.interceptors.request.use(
  (request) => {
    const source = axios.CancelToken.source();
    request.cancelToken = source.token;
    store.dispatch(Cancelation.addPendingRequest(source));
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/// Добавляет токен к запросам
apiCall.interceptors.request.use(
  (request) => {
    const storeData = JSON.parse(localStorage.getItem('token'));
    const access = storeData && storeData.access;

    if (access) {
      request.headers.Authorization = `Bearer ${access}`;
    }

    const { url } = request;
    if (url.includes('/login') || url.includes('/register')) {
      delete request.headers.Authorization;
    }

    return request;
  },
  (error) => Promise.reject(error)
);

// // Выход если получили 401 Unauthorized (потому что то что ниже нихера не работает)
// apiCall.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       store.dispatch(Cancelation.clearPendingRequests());
//       store.dispatch(Auth.logOut({ showToast: false }));
//     }
//   }
// );

// Хэндлим ошибки бекенда
apiCall.interceptors.response.use(
  (r) => r,
  async (error) => {
    const status = error && error.response && error.response.status;
    const errorData = error && error.response && error.response.data;
    const originalRequest = error.config;

    if (axios.isCancel(error)) {
      return;
    }

    if (process.env.NODE_ENV === 'development') {
      console.log(error.response);
    }

    /// Access token просрочен
    if (status === 401 && !originalRequest.url.includes('/login') && !originalRequest.url.includes('/register')) {
      if (!originalRequest._retry) {
        const storeData = JSON.parse(localStorage.getItem('token'));

        /// Отправляем запрос на получение нового access token'а
        if (storeData?.refresh) {
          originalRequest._retry = true;

          try {
            const { data } = await axios.post(`${baseURL}/refresh/`, { refresh: storeData.refresh });

            if (data) {
              localStorage.setItem('token', JSON.stringify(data));
              originalRequest.headers.Authorization = `Bearer ${data.access}`;
              return axios(originalRequest);
            }
          } catch (e) {
            /// Если пришла ошибка, проверяем, может другой параллельный запрос уже его получил
            const newStore = JSON.parse(localStorage.getItem('token'));
            const isTokenInvalid = error?.config?.headers['Authorization'] === `Bearer ${newStore?.access}`;

            if (!isTokenInvalid) {
              originalRequest.headers.Authorization = `Bearer ${newStore?.access}`;
              return axios(originalRequest);
            } else {
              store.dispatch(Auth.logOut({ showToast: false }));
            }
          }
        }
      } else {
        // localStorage.clear();
        store.dispatch(Auth.logOut({ showToast: false }));
      }
    }

    /// Отображение ошибки бекенда
    if (errorData) {
      if (errorData.detail && typeof errorData.detail === 'string') {
        errorToast(errorData.detail);
      } else if (typeof errorData === 'object') {
        const errors = [];
        for (const [keyErr, err] of Object.entries(errorData)) {
          errors.push(`${typeof err === 'object' ? JSON.stringify(err) : err}`);
        }

        if (errors.length > 0) {
          errorToast(errors.join('\n'));
        }
      }
    } else {
      errorToast('Ошибка соединения с сервером');
    }

    return Promise.reject(error);
  }
);

apiCall.defaults.headers.common = {
  'Content-Type': 'application/json',
};

export default (requestOptions) => apiCall(requestOptions);
